import axios from '@/axios';
import type { TSubmitLlmRatingPayload, TSubmitLlmCommentPayload } from '../models/types';

const BASE_URL = '/private/ui/llm-feedback';

const post = async <T>(url: string, payload: unknown): Promise<T> => {
  const { data } = await axios.post<T>(url, payload);
  return data;
};

export const llmFeedbackApi = {
  submitRating(payload: TSubmitLlmRatingPayload) {
    return post<void>(`${BASE_URL}/rate`, payload);
  },

  submitComment(payload: TSubmitLlmCommentPayload) {
    return post<void>(`${BASE_URL}/comment`, payload);
  },
};
